<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2a"><a id="page_10">Acknowledgments</a></h2><a id="page_10">
<p class="noindent"><span class="big">M</span>any thanks to Becky Cabaza and Carrie Thornton at Fireside, and to our lovely and talented agent, Kathleen Anderson. Thanks to Paula Ross of the YPN Group. As always, thanks to our parents for their generosity, encouragement, and bewildering enthusiasm for our “career.” And finally, thanks to all the schools listed in this book, both for responding to our requests for information and for offering such inspiring career training programs.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgments.vue?27f2ac98